export default __webpack_public_path__ + "static/media/close.4abc157d.svg";